var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Checklist',{staticClass:"pa-5",staticStyle:{"border-radius":"0px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }